<template>
    <div class="p-3 text-center" v-if="isDisplay">
        <!--qrcode-vue :value="value" :size="size" level="H" :key="newsletter.subcode"></qrcode-vue-->
        <p><strong>We're on Zigatext</strong></p>
        <keep-alive>
          <qrcode-vue 
            :size="size" 
            :value="value" 
            :logo="logo" 
            :bgColor="bgColor" 
            :fgColor="fgColor"
          ></qrcode-vue>
        </keep-alive>
        <span class="mt-2">{{url+subcode}}</span>
    </div>
    <div class="p-3" v-else>
      <p>This is a paid SMS Newsletter, subscribers to this list must have Zigatext account and will have to opt-in to your list by themselves because they will be the ones paying for the messages they receive from you through their own units.</p>
      <p>You can share this Newsletter's SUBCODE with them to enable them subscribe through <strong>Manage Newsletter</strong> menu item at the topright corner of the screen.</p>
    </div>
</template>

<script>
import Vue from 'vue'
import qrcodeVue from 'qrcode-vue'
import logo from '@/assets/icons/icon.png'

export default {
  name: 'QRCode',
  components: {
    qrcodeVue,
  },
  props: {
    url: String,
    isMobileDevice: Boolean,
    isDisplay: Boolean,
    subcode:String,
  },
  data(){
    return {
        value: 'URL:'+this.url+this.subcode,
        size: this.isMobileDevice ? 100 : 250,
        bgColor: '#fcfcfc',
        fgColor: '#000',
        logo: logo
    }
  },
}
</script>
